'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _InitialHelper = require('../helper/InitialHelper');

var _validateHelper = require('../helper/validateHelper');

var _util = require('../helper/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultConfig = {
  // 設定 domain url
  baseURL: undefined,
  logoutURL: undefined,
  apiURL: 'auth/checkticket',
  redirectTo: '/tube'
};

var withLoginPass = function withLoginPass() {
  var initialConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var config = Object.assign({}, defaultConfig, initialConfig);

  return function (Comp) {
    var WrappedComp = function (_Component) {
      _inherits(WrappedComp, _Component);

      function WrappedComp() {
        _classCallCheck(this, WrappedComp);

        return _possibleConstructorReturn(this, (WrappedComp.__proto__ || Object.getPrototypeOf(WrappedComp)).apply(this, arguments));
      }

      _createClass(WrappedComp, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var baseURL = config.baseURL,
              apiURL = config.apiURL,
              logoutURL = config.logoutURL;

          (0, _InitialHelper.initAxios)();
          (0, _validateHelper.validateURL)({ baseURL: baseURL, apiURL: apiURL, logoutURL: logoutURL });
          var queryStrings = _qs2.default.parse(window.location.search, { ignoreQueryPrefix: true });
          var code = queryStrings.code;
          var originUrl = queryStrings.red ? queryStrings.red : '' + window.location.origin + config.redirectTo;
          var locale = sessionStorage.locale;

          (0, _axios2.default)({
            method: 'get',
            url: config.apiURL,
            params: { code: code },
            baseURL: baseURL
          }).then(function (res) {
            sessionStorage.clear();
            sessionStorage.employee_id = res.data.employeeId;
            sessionStorage.company_id = res.data.companyId;
            sessionStorage.locale = locale;
            localStorage.setItem('refreshDate', (0, _moment2.default)().format('YYYY/MM/DD'));
            window.location.href = originUrl;
            // 紀錄domain使表單頁面可取得
            _jsCookie2.default.set('LoggedInDomain', window.location.hostname, { domain: '.mayohr.com' });
          }, function () {
            alert('認證失敗');
            window.location.href = config.logoutURL + '?original_target=' + originUrl;
          });
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Comp, this.props);
        }
      }]);

      return WrappedComp;
    }(_react.Component);

    WrappedComp.displayName = 'withLoginPass(' + (0, _util.getDisplayName)(Comp) + ')';
    return WrappedComp;
  };
};

exports.default = withLoginPass;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/login-pass/lib/components/withLoginPass.js
 ** module id = 2082
 ** module chunks = 30 33 69 71
 **/